(() => {
  'use strict';
  const init = (context = document) => {
    const sharepointNote = context.querySelector('[data-pe-sharepoint-note]');
    if (sharepointNote && new URLSearchParams(location.search).get('topic') === 'sharepoint') { sharepointNote.hidden = false; const body = document.querySelector('#ContactForm-body'); if (body && !body.value.trim()) body.value = sharepointNote.dataset.peSharepointBody; }

    context.querySelectorAll('[data-pe-finder]').forEach((finder) => {
      if (finder.dataset.initialized) return;
      finder.dataset.initialized = 'true';
      let step = 1;
      let family = '';
      let need = '';
      const next = finder.querySelector('[data-pe-next]');
      const back = finder.querySelector('[data-pe-back]');
      const results = finder.querySelector('[data-pe-results]');
      const render = () => {
        const group = step === 1 ? 'family' : family;
        finder.querySelectorAll('[data-pe-answers]').forEach((element) => { element.hidden = element.dataset.peAnswers !== group; });
        finder.querySelectorAll('[data-pe-answer]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.peAnswer === (step === 1 ? family : need)));
        });
        finder.querySelector('[data-pe-step]').textContent = step === 1 ? finder.dataset.stepOne : finder.dataset.stepTwo;
        finder.querySelector('[data-pe-question]').textContent = step === 1 ? finder.dataset.questionOne : finder.dataset[family === 'windows' ? 'questionWindows' : 'questionOffice'];
        next.textContent = (step === 1 ? finder.dataset.next : finder.dataset.showResult) + ' →';
        next.disabled = step === 1 ? !family : !need;
        back.hidden = step === 1;
      };
      finder.querySelectorAll('[data-pe-answer]').forEach((button) => button.addEventListener('click', () => {
        if (step === 1) { if (family !== button.dataset.peAnswer) need = ''; family = button.dataset.peAnswer; }
        else need = button.dataset.peAnswer;
        results.hidden = true;
        render();
      }));
      next.addEventListener('click', () => {
        if (next.disabled) return;
        if (step === 1) { step = 2; render(); return; }
        const key = family === 'windows' ? (need === 'everyday' ? 'winhome' : 'winpro') : (need === 'crossplatform' ? 'officehb' : 'officepro');
        finder.querySelectorAll('[data-pe-result]').forEach((element) => { element.hidden = element.dataset.peResult !== key; });
        results.hidden = false;
      });
      back.addEventListener('click', () => { step = 1; results.hidden = true; render(); });
      render();
    });
    context.querySelectorAll('[data-pe-language]').forEach((select) => {
      if (select.dataset.initialized) return;
      select.dataset.initialized = 'true';
      select.addEventListener('change', () => select.form.requestSubmit());
    });
    context.querySelectorAll('.product__description h2, .product__description h3, .product__description h4').forEach((heading) => {
      if (!/^Pinterest-?\s*&?\s*Social-Media-Optimierung$/i.test(heading.textContent.trim())) return;
      let sibling = heading.nextElementSibling;
      while (sibling && !/^H[1-6]$/.test(sibling.tagName)) { const following = sibling.nextElementSibling; sibling.remove(); sibling = following; }
      heading.remove();
    });
    context.querySelectorAll('.product__description strong').forEach((label) => {
      if (/^##\s/.test(label.textContent)) label.textContent = label.textContent.replace(/^##\s*/, '');
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
